import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('ResetPasswordApp => ');

const bootstrap = createAction('bootstrap form values', (userId, userEmail, isSupportUser) => ({
  userId,
  userEmail,
  isSupportUser,
}));
const updateField = createAction('update form values', (fieldId, value) => ({ fieldId, value }));

const onResetPasswordRequest = createAction('reset password request', (formRef, isValid) => ({ formRef, isValid }));
const onResetPasswordSuccess = createAction('rest password success');
const onResetPasswordFailure = createAction('rest password failure');

export default {
  bootstrap,
  updateField,

  onResetPasswordRequest,
  onResetPasswordSuccess,
  onResetPasswordFailure,
};
